export default "__VITE_ASSET__Cx$3OEkh__"